
import { getVendor, getVehicles} from './api.js'

import pageApiData from './utils/pageApiData.js'

const [ _getVendorFromServer, _getVendor, _getVendorSync ] = pageApiData.createFunctions(getVendor, 'Unable to get vendor data from server.')

const [ _getVehiclesFromServer, _getVehicles, _getVehiclesSync ] = pageApiData.createFunctions(getVehicles, 'Unable to get vendor data from server.')

async function getAllVendors() {
  return _getVendorFromServer()
}

async function getVendorByCode(code) {
  return (await _getVendor(code))
}

function getVendorByCodeSync(code) {
  return (_getVendorSync(code))
}

async function getAllVehicles() {
  return _getVehiclesFromServer()
}

async function getVehiclesByCode(code) {
  console.log(code)
  return (await _getVehicles(code))
}

async function getVehiclesFromVendor(code) {
  console.log(code)
  let promise = getVehicles(code)
  return promise
}

function getVehiclesByCodeSync(code) {
  return (_getVehiclesSync(code))
}

export default {
  getVendorFromServer: _getVendorFromServer,
  getVendor: _getVendor,
  getVendorSync: _getVendorSync,

  getVehiclesFromServer: _getVehiclesFromServer,
  getVehicles: _getVehicles,
  getVehiclesSync: _getVehiclesSync,

  getAllVendors,
  getVendorByCode,
  getVendorByCodeSync,

  getAllVehicles,
  getVehiclesByCode,
  getVehiclesByCodeSync,
  getVehiclesFromVendor,
}
